import { Component, Input } from '@angular/core';

@Component({
  selector: 'mh-circular-progress',
  templateUrl: './circular-progress.component.html',
  styleUrls: ['./circular-progress.component.scss'],
  standalone: false,
})
export class CircularProgressComponent {
  @Input() percentageValue: number;
  @Input() fillValue: number;
  @Input() diameter: number;
  @Input() strokeWidth: number;
  @Input() doubleFill = false;
  @Input() colorScheme: 'qualification' | 'default' = 'default';
  @Input() qualification: 'excellent' | 'good' | 'regular' | 'bad' | 'very-bad' | 'no-data';
  @Input() nps: 'promoter' | 'passive' | 'detractor';
}
